import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { RequestContext } from '@utils'
import * as playerConfig from './integration/config'
import { PlaybackArea } from './integration/playbackArea'
import { PlaybackContentLink, PlayerIntegration, PlayerContentConfig } from '.'

type SimplePlayerProps = {
  requestContext: RequestContext
  pageType: playerConfig.PageType
  launchType: WpsRuntime.atv.wps.DeeplinkingLaunchType
  whisperCacheData?: PlayerContentConfig
  liveIncompatibleCallback?: () => void
  isEnabled?: boolean
}

type SimplePlayerState = {
  playbackContent: PlaybackContentLink | undefined
}

export class SimplePlayer extends React.Component<
  SimplePlayerProps,
  SimplePlayerState
> {
  constructor(props: SimplePlayerProps) {
    super(props)
    this.state = { playbackContent: undefined }
  }

  setContent(playbackContent: PlaybackContentLink) {
    this.setState({ playbackContent })
  }

  render() {
    const {
      requestContext,
      pageType,
      launchType,
      whisperCacheData,
      liveIncompatibleCallback,
      isEnabled = true,
      children,
    } = this.props
    const { playbackContent } = this.state
    const { sessionID, marketplaceID, customerID, locale } = requestContext
    const playerConfig = {
      sessionId: sessionID,
      marketplaceId: marketplaceID,
      customerId: customerID,
      locale,
      playerBeta: false,
      useDefaultView: true,
      pageType,
    }

    if (!isEnabled) {
      return <>{children}</>
    }

    return (
      <>
        {launchType === 'EMBEDDED' && (
          <PlayerIntegration
            playerConfig={playerConfig}
            playbackLinkData={playbackContent}
            whisperCacheData={whisperCacheData}
            liveIncompatibleCallback={liveIncompatibleCallback}
            onClosed={() => this.setContent(undefined)}
          />
        )}
        <PlaybackArea
          pageType={pageType}
          onPlay={this.setContent.bind(this)}
          launchType={launchType}
          trailerLaunchType={launchType}>
          {children}
        </PlaybackArea>
      </>
    )
  }
}
